export default __webpack_public_path__ + "static/media/users-details-edit.38e73203.png";